module.exports = __webpack_public_path__ + "img/Jump Casting34.cfc98146.jpg";